'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_api_DocumentsAuditLogListResponse(docInfo, results) {
  this.Xj = null;
  this.Kr = null;
  this.Xj = docInfo;
  this.Kr = results;
}
export { $c_Lapp_api_DocumentsAuditLogListResponse as $c_Lapp_api_DocumentsAuditLogListResponse };
$p = $c_Lapp_api_DocumentsAuditLogListResponse.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_api_DocumentsAuditLogListResponse;
/** @constructor */
function $h_Lapp_api_DocumentsAuditLogListResponse() {
}
export { $h_Lapp_api_DocumentsAuditLogListResponse as $h_Lapp_api_DocumentsAuditLogListResponse };
$h_Lapp_api_DocumentsAuditLogListResponse.prototype = $p;
$p.z = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_api_DocumentsAuditLogListResponse)) {
    var x = this.Xj;
    var x$2 = x$0.Xj;
    if (((x === null) ? (x$2 === null) : x.f(x$2))) {
      var x$3 = this.Kr;
      var x$4 = x$0.Kr;
      return ((x$3 === null) ? (x$4 === null) : x$3.f(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 2;
});
$p.t = (function() {
  return "DocumentsAuditLogListResponse";
});
$p.e = (function(n) {
  if ((n === 0)) {
    return this.Xj;
  }
  if ((n === 1)) {
    return this.Kr;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.u = (function(n) {
  if ((n === 0)) {
    return "docInfo";
  }
  if ((n === 1)) {
    return "results";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lapp_api_DocumentsAuditLogListResponse(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.io)));
}
export { $isArrayOf_Lapp_api_DocumentsAuditLogListResponse as $isArrayOf_Lapp_api_DocumentsAuditLogListResponse };
var $d_Lapp_api_DocumentsAuditLogListResponse = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_api_DocumentsAuditLogListResponse, "app.api.DocumentsAuditLogListResponse", ({
  io: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lapp_api_DocumentsAuditLogListResponse as $d_Lapp_api_DocumentsAuditLogListResponse };
//# sourceMappingURL=app.api.-Documents-Audit-Log-List-Response.js.map
